import { useMemo } from 'react';
import {
  i18nInit,
  useLanguageControlOverrides,
  useLoadLocale
} from '@elfsight/lib-i18n';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { CustomCSS, createCustomCSSPrefixClassName } from '@elfsight/widget-ui';
import { CacheProvider } from '@elfsight/widget-utils';
import { I18nProvider } from '@lingui/react';
import { useSettings } from '@wu/widget-core';
import CATALOG from '../i18n/languages/widget/catalog.json';
import { meta } from './meta';
import { Widget } from './widget/widget';

export function Weather() {
  const {
    editMode,
    renderThumbnailMode,
    language,
    widgetId = 'test-widget-id',
    customCSS,
    customJS
  } = useSettings();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.alias,
    widgetId
  );

  const i18n = useMemo(() => i18nInit(), []);
  const messages = useLoadLocale(language?.language, 'widget', i18n);
  useLanguageControlOverrides({ language, messages, catalog: CATALOG, i18n });

  useDefineAPISchema();
  useCustomJS(customJS, editMode || renderThumbnailMode);

  return (
    <I18nProvider i18n={i18n}>
      <CacheProvider prefix={meta.name}>
        <CustomCSS
          customCSS={customCSS}
          prefixClassName={customCSSPrefixClassName}
        />

        <Widget customCSSPrefixClassName={customCSSPrefixClassName} />
      </CacheProvider>
    </I18nProvider>
  );
}
